import { Button } from "react-bootstrap"

const CreateRatePlanButton = ({ openDrawer }) => {

  return (

    <div className="mb-4">

      <Button
        variant="primary"
        className="px-4 py-2 fw-semibold color-white"
        style={{
          borderRadius: "10px"
        }}
        onClick={openDrawer}
      >
        + Créer un tarif
      </Button>

    </div>

  )
}

export default CreateRatePlanButton